import { Getter, Setter } from "../services/ComService"
import { Emoji2PlainText, Emoji2Unicode } from "../services/EmojiServices"
import { IPreference, Preference, PreferenceCategorie, PreferenceType, PreferenceValue, prefs } from "./PreferencesConfig"

export class PreferenceDTO {
  id: number = -1
  name: string
  key1: string
  key2: string
  values: PreferenceValue[]
  kind: string
  type: PreferenceType
  standard: any
  description: string
  page: number
  encrypt: boolean = false
  constructor(data: Preference) {
    this.id = data.id || -1
    this.name = data.name
    this.key1 = data.key1
    this.key2 = data.key2
    this.values = []
    this.kind = data.kind
    this.type = data.type
    this.standard = data.standard
    this.description = data.description || ''
    this.page = data.page || 0
    this.encrypt = data.encrypt || false
  }

  public initData(data: IPreference) {
    // this.key1 = data.key1
    // this.key2 = data.key2
    try {
      this.id = data.id || -1
    } catch(err) {
      throw new Error('not logged in?')
    }
    this.values = data.values.map(v => {
      let newV = {
        id: v.id,
        value1: Emoji2Unicode(v.value1),
        value2: Emoji2Unicode(v.value2),
        start: v.start ? new Date(v.start.date) : null,
        end: v.end ? new Date(v.end.date) : null,
        file: null,
        encrypt: this.encrypt,
      }
      return newV
    })
    this.kind = data.kind
  }

  public async saveValue(valueId: number) {
    const value = this.values.find(v => v.id === valueId)
    if (!value) {
      return
    }
    const data: any = await Setter('preferences/set', {
      id: value.id,
      fileId: value.file?.id || -1,
      key1: this.key1,
      key2: this.key2,
      value1: Emoji2PlainText(value.value1),
      value2: Emoji2PlainText(value.value1),
      start: value.start,
      end: value.end,
      kind: this.kind,
      type: this.type,
      encKey: this.encrypt ? -1 : 0,
    })
    if (valueId === -1) {
      const newData: any = await Setter('preferences/getPreference', {
        id: this.id
      })
      this.initData(newData)
    } else {
      this.initData(data)
    }
    
  }

  public async saveDate(valueId: number, d: Date | null, t: 'start' | 'end') {
    const value = this.values.find(v => v.id === valueId)
    if (!value) {
      return
    }
    if (t === 'start') {
      value.start = d
      if (value.start && value.end && value.start > value.end) {
        value.end = value.start
      }
    } else {
      value.end = d
      if (value.start && value.end && value.start > value.end) {
        value.start = value.end
      }
    }
    await this.saveValue(valueId)
  }

  public async removeValue(valueId: number) {
    this.values = this.values.filter(v => v.id !== valueId)
    const data: any = await Setter('preferences/removeValue', {
      preferenceId: this.id,
      valueId: valueId
    })
    this.initData(data)
  }

  public async setValue(valueId: number, valueValue: string) {
    let value = this.values.find(v => v.id === valueId) || {
      id: valueId,
      value1: '',
      value2: '',
      start: null,
      end: null,
      file: null,
    }
    const result: any = await Setter('preferences/set', {
      id: (value.start === null && value.end === null) ? -1 : value.id,
      fileId: value.file?.id || -1,
      key1: this.key1,
      key2: this.key2,
      value1: Emoji2PlainText(valueValue),
      value2: Emoji2PlainText(value.value2),
      start: value.start,
      end: value.end,
      kind: this.kind,
      type: this.type,
      encKey: this.encrypt ? -1 : 0,
    })
    this.initData(result)
    return valueValue
  }

  public getValues(): PreferenceValue[] {
    return this.values.filter(v => !(v.start === null && v.end === null))
  }

  public getDefaultValue(): PreferenceValue {
    return this.values.find(v => v.start === null && v.end === null) || {
      id: -1,
      value1: this.standard,
      value2: '',
      start: null,
      end: null,
      file: null,
    }
  }

  public getCurrent(): PreferenceValue {
    const theDefault = this.getDefaultValue()
    const theCurrents: PreferenceValue[] = this.values.filter(v => (v.start && v.start < new Date()) && (v.end === null || v.end > new Date()))
    if (theCurrents) {
      const sorted = theCurrents.sort((a, b) => (a.start as any) - (b.start as any))
      return sorted[sorted.length - 1]
    }
    return theDefault
  }

  public getCurrentVal1 = () => {
    const now = new Date()
    const theDefault = this.values.find(v => v.start === null && v.end === null)?.value1 || ''
    const theCurrents = this.values.filter(v => (v.start && v.start < now) && (v.end === null || v.end > now))
    if (theCurrents && theCurrents.length > 0) {
      const sorted = theCurrents.sort((a, b) => (a.start as any) - (b.start as any))
      return sorted[sorted.length - 1].value1 || ''
    }
    return theDefault
  }

  public initNewValue() {
    this.values.push(
      {
        id: -1,
        value1: '',
        value2: '',
        start: new Date(),
        end: new Date(),
        file: null,
      }
    )
  }
}


export class PreferencesDTO {

  prefs: PreferenceDTO[] = []
  // categories: string[] = []
  categories: PreferenceCategorie[] = []
  initDone: boolean = false

  constructor() {
    // let ps: PreferenceDTO[] = []
    prefs.forEach((category, index) => {
      this.categories.push(category)
      category.preferences.forEach(p => {
        p.page = index
        this.prefs.push(new PreferenceDTO(p))
      })
    })
    // this.prefs = ps
    return
  }

  public async init() {
    if (!this.initDone) {
      await this.getFromServer()
    }
  }

  private initData(data: IPreference[]) {
    try {
      data.forEach(d => {
        const l = this.getPref(d.key1, d.key2)
        if (!l) { return }
        l.initData(d)
      })
    } catch(err) {
      throw new Error('not logged in?')
    }
    this.initDone = true
  }

  public getPref(key1: string, key2: string): PreferenceDTO | undefined {
    return this.prefs.find(l => l.key1 === key1 && l.key2 === key2)
  }

  public getVal(key1: string, key2: string): string {
    const l = this.getPref(key1, key2)
    if (!l) { return '' }
    const result = l?.getCurrentVal1() || ''
    return result
  }

  private async getFromServer() {
    const data = await Getter('preferences/list')
    this.initData(data)
  }

  public list(page?: number) {
    return this.prefs.filter(p => page === undefined || p.page === page)
  }

  public listCategories(version?: string) {
    return this.categories.filter(c => version === undefined || c.version === 'both' || c.version === version).map(c => c.name)
  }
}

const PreferenceService = new PreferencesDTO()
export default PreferenceService
